import { render, staticRenderFns } from "./ClinicUsersPage.vue?vue&type=template&id=66919d53&scoped=true"
import script from "./ClinicUsersPage.vue?vue&type=script&lang=js"
export * from "./ClinicUsersPage.vue?vue&type=script&lang=js"
import style0 from "./ClinicUsersPage.vue?vue&type=style&index=0&id=66919d53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66919d53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
